import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
// core components
import Login from "../pages/Login.js";
import ForgetPassword from "../pages/ForgotPassword.js";
import Resetpassword from "../pages/ResetPassword.js";

const Auth = (props) => {
  return (
    <>
      <div className="" >
       
       
            <Routes>
              <Route path="/" element={<Login />} exact />
              <Route path="/forget-password" element={<ForgetPassword />} exact />
              <Route path="/reset-password" element={<Resetpassword />} exact />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          
          
      </div>
    </>
  );
};

export default Auth;
